/* @flow */

import * as entititesTypes from 'src/shared/domain/base/action/entityActionTypes';
import * as types from 'src/shared/domain/user/action/userActionTypes';
import {
  createReducer,
  patchEntities,
} from 'src/shared/core/util/reducerUtils';

import type { State } from 'src/shared/core/type/reduxTypes';

const initialState = {};

const _updateUserActivity = (state: Object, action: Object) => {
  const { result, userId } = action;
  const user = state[userId];

  if (user) {
    return {
      ...state,
      [`${userId}`]: {
        ...user,
        activity: result,
      },
    };
  }
  return state;
};

const _updateStats = (state: Object, action: Object) => {
  const { result, userId } = action;
  const user = state[userId];

  if (user) {
    return {
      ...state,
      [`${userId}`]: {
        ...user,
        statistics: result,
      },
    };
  }
  return state;
};

const _updateUserAvatar = (state: Object, action: Object) => {
  const { result, userId } = action;
  const user = state[userId];

  if (user) {
    return {
      ...state,
      [`${userId}`]: {
        ...user,
        avatar: result,
      },
    };
  }
  return state;
};

const _patch = (state: Object, action: Object) =>
  patchEntities(state, action, 'users');

const resetTopicKeywords = (state: State, { userId }: Object) => {
  const user = state[userId];

  if (user) {
    return {
      ...state,
      [userId]: {
        ...user,
        keywords: [],
      },
    };
  }

  return state;
};

const setTopicKeywords = (state: State, { userId, result }: Object) => {
  const user = state[userId];

  if (user) {
    return {
      ...state,
      [userId]: {
        ...user,
        keywords: result,
      },
    };
  }

  return state;
};

const resetInterests = (state: State, { userId }: Object) => {
  const user = state[userId];

  if (user) {
    return {
      ...state,
      [userId]: {
        ...user,
        interests: [],
      },
    };
  }

  return state;
};

const setInterests = (state: State, { userId, result }: Object) => {
  const user = state[userId];

  if (user) {
    return {
      ...state,
      [userId]: {
        ...user,
        interests: result,
      },
    };
  }

  return state;
};

export default createReducer(initialState, {
  [types.FETCH_USER_ACTIVITY_SUCCESS]: _updateUserActivity,
  [types.FETCH_USER_STATISTICS_SUCCESS]: _updateStats,
  [types.FETCH_USER_TOPIC_KEYWORDS_REQUEST]: resetTopicKeywords,
  [types.FETCH_USER_TOPIC_KEYWORDS_SUCCESS]: setTopicKeywords,
  [types.FETCH_USER_TOPIC_KEYWORDS_FAILURE]: resetTopicKeywords,
  [types.FETCH_USER_INTERESTS_REQUEST]: resetInterests,
  [types.FETCH_USER_INTERESTS_SUCCESS]: setInterests,
  [types.FETCH_USER_INTERESTS_FAILURE]: resetInterests,
  [types.UPDATE_AVATAR_SUCCESS]: _updateUserAvatar,
  [entititesTypes.PATCH_ENTITIES]: _patch,
});
